var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 23",
    style: {
      enableBackground: "new 0 0 12 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,0c0.66,0,1.2,0.57,1.2,1.28v1.38c1.09,0.18,2.09,0.61,2.9,1.25C11.21,4.78,12,6.09,12,7.67 c0,0.71-0.54,1.28-1.2,1.28c-0.66,0-1.2-0.57-1.2-1.28c0-0.6-0.29-1.2-0.92-1.7C8.04,5.46,7.09,5.11,6,5.11S3.96,5.46,3.32,5.96 C2.69,6.46,2.4,7.07,2.4,7.67c0,0.6,0.29,1.2,0.92,1.7c0.64,0.5,1.58,0.85,2.68,0.85c1.55,0,3,0.48,4.1,1.35 c1.11,0.87,1.9,2.18,1.9,3.76s-0.79,2.88-1.9,3.76c-0.81,0.64-1.81,1.07-2.9,1.25v1.38C7.2,22.43,6.66,23,6,23s-1.2-0.57-1.2-1.28 v-1.38c-1.09-0.18-2.09-0.61-2.9-1.25C0.79,18.22,0,16.91,0,15.33c0-0.71,0.54-1.28,1.2-1.28c0.66,0,1.2,0.57,1.2,1.28 c0,0.6,0.29,1.2,0.92,1.7c0.64,0.51,1.58,0.85,2.68,0.85s2.04-0.35,2.68-0.85c0.63-0.5,0.92-1.11,0.92-1.7c0-0.6-0.29-1.2-0.92-1.7 c-0.64-0.5-1.58-0.85-2.68-0.85c-1.55,0-3-0.48-4.1-1.35C0.79,10.55,0,9.24,0,7.67c0-1.57,0.79-2.88,1.9-3.76 c0.81-0.64,1.81-1.07,2.9-1.25V1.28C4.8,0.57,5.34,0,6,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheap);
export default __webpack_public_path__ + "static/media/cheap.76c2d40b412bd547ece3be694257dacd.svg";
export { ForwardRef as ReactComponent };